import * as types from './constants';

// Handoff Lookbook Order Shopify
export const handoffLookbookOrderShopifyRequest = data => (
  { type: types.HANDOFF_LOOKBOOK_ORDER_SHOPIFY_REQUEST, payload: data }
);

export const handoffLookbookOrderShopifyDone = data => (
  { type: types.HANDOFF_LOOKBOOK_ORDER_SHOPIFY_DONE, payload: data }
);

export const handoffLookbookOrderShopifyFailed = errors => (
  { type: types.HANDOFF_LOOKBOOK_ORDER_SHOPIFY_FAILED, payload: errors }
);

export const handoffLookbookOrderShopifyClearErrors = prop => (
  { type: types.HANDOFF_LOOKBOOK_ORDER_SHOPIFY_CLEAR_ERRORS, payload: prop }
);

export const handoffLookbookOrderShopifyReset = () => (
  { type: types.HANDOFF_LOOKBOOK_ORDER_SHOPIFY_RESET }
);
